/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * What the mapping matches.
 */
export const SetDirectoryRoleMappingFormSourceKind = {
  Group: "group",
  Attribute: "attribute",
} as const;
/**
 * What the mapping matches.
 */
export type SetDirectoryRoleMappingFormSourceKind = ClosedEnum<
  typeof SetDirectoryRoleMappingFormSourceKind
>;

export type SetDirectoryRoleMappingForm = {
  /**
   * Attribute key to match. Required when source_kind is attribute.
   */
  attributeKey?: string | undefined;
  /**
   * Attribute value to match. Required when source_kind is attribute.
   */
  attributeValue?: string | undefined;
  /**
   * Directory group to map. Required when source_kind is group.
   */
  directoryGroupId?: string | undefined;
  /**
   * Principal URN of the role to grant, from Role.principal_urn.
   */
  roleUrn: string;
  /**
   * What the mapping matches.
   */
  sourceKind: SetDirectoryRoleMappingFormSourceKind;
};

/** @internal */
export const SetDirectoryRoleMappingFormSourceKind$outboundSchema:
  z.ZodMiniEnum<typeof SetDirectoryRoleMappingFormSourceKind> = z.enum(
    SetDirectoryRoleMappingFormSourceKind,
  );

/** @internal */
export type SetDirectoryRoleMappingForm$Outbound = {
  attribute_key?: string | undefined;
  attribute_value?: string | undefined;
  directory_group_id?: string | undefined;
  role_urn: string;
  source_kind: string;
};

/** @internal */
export const SetDirectoryRoleMappingForm$outboundSchema: z.ZodMiniType<
  SetDirectoryRoleMappingForm$Outbound,
  SetDirectoryRoleMappingForm
> = z.pipe(
  z.object({
    attributeKey: z.optional(z.string()),
    attributeValue: z.optional(z.string()),
    directoryGroupId: z.optional(z.string()),
    roleUrn: z.string(),
    sourceKind: SetDirectoryRoleMappingFormSourceKind$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      attributeKey: "attribute_key",
      attributeValue: "attribute_value",
      directoryGroupId: "directory_group_id",
      roleUrn: "role_urn",
      sourceKind: "source_kind",
    });
  }),
);

export function setDirectoryRoleMappingFormToJSON(
  setDirectoryRoleMappingForm: SetDirectoryRoleMappingForm,
): string {
  return JSON.stringify(
    SetDirectoryRoleMappingForm$outboundSchema.parse(
      setDirectoryRoleMappingForm,
    ),
  );
}
